import { render } from "./StatusDokumenPengadaanInfo.vue?vue&type=template&id=bdf670b8"
import script from "./StatusDokumenPengadaanInfo.vue?vue&type=script&lang=js"
export * from "./StatusDokumenPengadaanInfo.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__